import { render, staticRenderFns } from "./PageServiceModelBrowse.vue?vue&type=template&id=5c46b818&scoped=true&"
import script from "./PageServiceModelBrowse.vue?vue&type=script&lang=js&"
export * from "./PageServiceModelBrowse.vue?vue&type=script&lang=js&"
import style0 from "./PageServiceModelBrowse.vue?vue&type=style&index=0&id=5c46b818&scoped=true&lang=css&"
import style1 from "./PageServiceModelBrowse.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46b818",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtnToggle,VCard,VContainer,VIcon})
